/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { Resource } from '@common/application/enums/Resource';
import { ResourceStatus } from '@common/application/enums/ResourceStatus';
import { ResourceUrl } from '@common/application/helpers/generateSignedUrlsForResults';
import uploadFileToSignedUrl from '@common/application/helpers/uploadFileToSignedUrl';
import { AttachmentTypeValue } from '@common/model/apiClient/AttachmentType';
import { ApiResponse } from '@common/types/api';
import { ElasticQueryOpts, ElasticResponse, ElasticSearchAfter, ElasticSort } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';

export type TAttachment = ResourceUrl | { url: File; urlStatus: ResourceStatus };
export class Attachment {
  id: number;
  description: string;
  filename: string;
  attachment: TAttachment;
  documentId: number;
  attachmentTypeId: AttachmentTypeValue;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  constructor(description: string, filename: string, attachment: TAttachment, documentId: number, attachmentTypeId: AttachmentTypeValue) {
    this.description = description;
    this.filename = filename;
    this.attachment = attachment;
    this.documentId = documentId;
    this.attachmentTypeId = attachmentTypeId;
  }

  static list(
    query,
    sort: ElasticSort,
    queryOpts: ElasticQueryOpts,
    size?: number,
    pit?: Nullable<string>,
    search_after?: Nullable<ElasticSearchAfter>,
  ): ElasticResponse<Attachment> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/attachments`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            queryOpts: JSON.stringify(queryOpts),
            sort: JSON.stringify(sort),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static delete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.delete(`/api/v1/attachments/${id}`).then((res) => ({ ...res.data }));
  }

  async add(): ApiResponse<Attachment> {
    return axiosInstance
      .post(
        `/api/v1/attachments`,
        {
          payload: {
            meta: {
              description: this.description,
              filename: this.filename,
              documentId: this.documentId,
              attachmentTypeId: this.attachmentTypeId,
            },
            // file: this.attachment,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .then(async (res) => {
        const { signedUrl } = res.data.payload;
        await uploadFileToSignedUrl(signedUrl, this.attachment.url as File, res.data.payload, 'attachment', Resource.ATTACHMENT);
        return { ...res.data };
      })
      .catch((error) => {
        throw error;
      });
  }
}
